// @ts-ignore
import debounce from 'lodash/debounce';
// @ts-ignore
import Masonry from 'masonry-layout';
// @ts-ignore
import ImagesLoaded from 'imagesloaded';
import {Audioplayer} from "./AudioplayerClass";
import {Slider} from "./SliderClass";

export class Timeline {

    private frames: NodeListOf<HTMLElement>;
    private unloadedFrames: any;

    constructor() {
        this.frames = document.querySelectorAll('[data-timeline]');
        this.unloadedFrames = [];
        this.frames.forEach((frame) => {
            this.unloadedFrames.push(frame);
        });
        this.addEventListeners();
        if (window.location.hash) {
            document.querySelector(window.location.hash).scrollIntoView({behavior: 'smooth'});
        } else {
            this.loadFrames();
        }
    }

    private addEventListeners() {
        window.addEventListener('scroll', debounce(() => {this.loadFrames()}, 500));

        this.frames.forEach(frame => {
            frame.addEventListener('turbo:frame-load', () => {

                const timeline = frame.querySelector('[data-timeline-container]');

                const msnry = new Masonry(timeline, {
                    itemSelector: "[data-timeline-entry]"
                });

                ImagesLoaded(frame, () => {
                    msnry.layout();
                });

                frame.querySelectorAll('video').forEach(video => {
                    video.addEventListener('loadeddata', () => {
                        msnry.layout();
                    });
                });

                frame.querySelectorAll('[data-audioplayer]').forEach(player => {
                    new Audioplayer(player);
                });

                frame.querySelectorAll('[data-slider]').forEach(slider => {
                    new Slider(slider);
                });
            })
        });
    }

    private isScrolledIntoView(el) {
        var rect = el.getBoundingClientRect();
        var minHeight = window.innerHeight * 0.75;
        if (minHeight < 320) {
            minHeight = 320
        }
        return rect.top < minHeight && rect.bottom >= 228;
    }

    private loadFrames() {
        this.unloadedFrames.forEach((frame, index) => {
            if (this.isScrolledIntoView(frame)) {
                frame.setAttribute('src', frame.dataset.timelineSrc);
                this.unloadedFrames.splice(index, 1);
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new Timeline();
});
